import * as React from 'react';
import { observer } from 'mobx-react';
import { Media } from '../../Utils/Responsive';
import { Advert as AdvertComponent } from '../../Advert';
import { Advert } from '../../../models';
import './style.css';

export interface TileIndexProps<T> {
  advertSlotOne?: Array<Advert>;
  advertSlotTwo?: Array<Advert>;
  getTile: (item: T) => JSX.Element;
  items?: Array<T>;
}

export interface TileIndexState {
  /* empty*/
}

@observer
export class TileIndex<T> extends React.Component<
  TileIndexProps<T>,
  TileIndexState
> {
  render() {
    const { advertSlotOne } = this.props;

    const desktopQuery = this.getDesktopAdvertMediaQuery(advertSlotOne);

    return (
      <Media query={desktopQuery}>
        {(matched: boolean) =>
          matched
            ? /* TODO: Split into separate components... */
              this.getDesktopTiles()
            : this.getMobileTiles()
        }
      </Media>
    );
  }

  /**
   * Try to pull desktop media query from advert with "largest media query"
   * (e.g. largest minWidth).
   * Else fallback to (min-width: 1280px).
   */
  private getDesktopAdvertMediaQuery = (
    adverts: Array<Advert> | undefined
  ): string => {
    const defaultMediaQuery = `(min-width: 1280px)`;

    if (!adverts) {
      return defaultMediaQuery;
    }

    const advertsSortedByMinWidth = adverts
      .slice()
      .sort(
        (advertA, advertB) =>
          advertB.minWidth == null ||
          (advertA.minWidth as number) > (advertB.minWidth as number)
            ? -1
            : 1
      );

    return (
      (advertsSortedByMinWidth.length &&
        advertsSortedByMinWidth[0].mediaQuery) ||
      defaultMediaQuery
    );
  };

  private getDesktopTiles = (): JSX.Element => {
    const {
      advertSlotOne,
      advertSlotTwo,
      children,
      getTile,
      items
    } = this.props;

    return (
      <div className="category-tiles-outer-wrapper">
        <div className="category-tiles-wrapper">
          <section className="category-tiles">
            {children}
            {this.getTiles(items, getTile)}
          </section>
          <aside className="category-index-adverts-wrapper">
            <AdvertComponent
              className="category-index-advert"
              adverts={advertSlotOne}
            />
            <AdvertComponent
              className="category-index-advert"
              adverts={advertSlotTwo}
            />
          </aside>
        </div>
      </div>
    );
  };

  private getMobileTiles = (): JSX.Element | null => {
    const {
      advertSlotOne,
      advertSlotTwo,
      children,
      getTile,
      items
    } = this.props;
    const firstBlockOfTiles = this.getTileBlock(
      this.getTiles(items, getTile, 0, 4)
    );
    const secondBlockOfTiles = this.getTileBlock(
      this.getTiles(items, getTile, 4, 4)
    );
    const thirdBlockOfTiles = this.getTileBlock(
      this.getTiles(items, getTile, 8)
    );

    let firstAdvert = null;
    if (advertSlotOne && advertSlotOne.length) {
      firstAdvert = (
        <aside className="category-banner-advert-wrapper">
          <AdvertComponent
            className="category-index-banner-advert"
            adverts={advertSlotOne}
          />
        </aside>
      );
    }

    let secondAdvert = null;
    if (secondBlockOfTiles && advertSlotTwo && advertSlotTwo.length) {
      secondAdvert = (
        <aside className="category-banner-advert-wrapper">
          <AdvertComponent
            className="category-index-banner-advert"
            adverts={advertSlotTwo}
          />
        </aside>
      );
    }

    return (
      <div className="category-tiles-wrapper">
        {children}
        {firstBlockOfTiles}
        {firstAdvert}
        {secondBlockOfTiles}
        {secondAdvert}
        {thirdBlockOfTiles}
      </div>
    );
  };

  private getTileBlock = (tiles: Array<JSX.Element>): JSX.Element | null => {
    if (!tiles.length) {
      return null;
    }

    return <section className="category-tiles-block">{tiles}</section>;
  };

  private getTiles = (
    items: Array<T> = [],
    getTile: (item: T) => JSX.Element,
    offset: number = 0,
    count: number = items.length - offset
  ): Array<JSX.Element> => {
    return items.slice(offset, offset + count).map(getTile);
  };
}

export default TileIndex;



// WEBPACK FOOTER //
// ./src/app/components/Common/TileIndex/index.tsx